import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import UserList from '../Views/users/UserList';
import Categories from '../Views/category/Categories';
import Dashboard from '../Views/Dashboard';
import SingleUser from '../Views/users/SingleUser';
import EditUser from '../Views/users/EditUser';
import CreateHouse from '../Views/houses/CreateHouse';
import AllHouses from '../Views/houses/AllHouses';
import Plans from '../Views/plans/Plans';
import HouseDetail from '../Views/houses/SingleHouse';
import AdminBroadcast from '../Views/Brodcast';
import Banners from '../Views/Banners';
import ProductDetail from '../Views/houses/SingleHouse';

const AdminPanel = () => {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1024);
    const [darkMode, setDarkMode] = useState(false);
    const [collapsed, setCollapsed] = useState(() => {
        const saved = localStorage.getItem('sidebarCollapsed');
        return window.innerWidth >= 1024 ? (saved === 'true' || false) : false;
    });

    // Handle window resize with debounce
    useEffect(() => {
        let timeoutId;
        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                if (window.innerWidth < 768) {
                    setSidebarOpen(false);
                    setCollapsed(false);
                } else if (window.innerWidth < 1024) {
                    setSidebarOpen(true);
                    setCollapsed(true);
                } else {
                    setSidebarOpen(true);
                }
            }, 150);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const toggleCollapsed = () => {
        if (window.innerWidth >= 1024) {
            const newCollapsed = !collapsed;
            setCollapsed(newCollapsed);
            localStorage.setItem('sidebarCollapsed', newCollapsed);
        }
    };

    const toggleDarkMode = () => {
        const newDarkMode = !darkMode;
        setDarkMode(newDarkMode);
        localStorage.setItem('darkMode', newDarkMode);
        document.documentElement.classList.toggle('dark', newDarkMode);
    };

    const handleNavigation = (path) => {
        navigate(`/admin${path}`);
        if (window.innerWidth < 768) {
            setSidebarOpen(false);
        }
    };

    // Load preferences
    useEffect(() => {
        const savedDarkMode = localStorage.getItem('darkMode') === 'true';
        setDarkMode(savedDarkMode);
        document.documentElement.classList.toggle('dark', savedDarkMode);
    }, []);

    return (
        <div className={`min-h-screen ${darkMode ? 'dark bg-gray-900' : 'bg-red-50'}`}>
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <Sidebar
                    sidebarOpen={sidebarOpen}
                    darkMode={darkMode}
                    toggleSidebar={toggleSidebar}
                    collapsed={collapsed}
                    toggleCollapsed={toggleCollapsed}
                    onNavigate={handleNavigation}
                />

                {/* Main Content Area */}
                <div className={`
                    flex-1 flex flex-col 
                    transition-all duration-300 ease-in-out
                    w-full
                    ${sidebarOpen ? 'md:ml-0' : 'md:ml-0'}
                `}>
                    {/* Navbar */}
                    <Navbar
                        toggleSidebar={toggleSidebar}
                        toggleDarkMode={toggleDarkMode}
                        darkMode={darkMode}
                        collapsed={collapsed}
                        sidebarOpen={sidebarOpen}
                        onNavigate={handleNavigation}
                    />

                    {/* Main Content Area with Routes */}
                    <main className={`
                        flex-1 overflow-y-auto overflow-x-hidden
                        p-3 sm:p-4 md:p-5 lg:p-6
                        transition-all duration-300
                        ${darkMode ? 'scrollbar-dark' : 'scrollbar-light'}
                    `}>
                        <div className="container mx-auto max-w-7xl">
                            <Routes>
                                <Route path="/" element={<Dashboard darkMode={darkMode} collapsed={collapsed} />} />
                                <Route path="/dashboard" element={<Dashboard darkMode={darkMode} collapsed={collapsed} />} />

                                <Route path="/users" element={<UserList darkMode={darkMode} collapsed={collapsed} />} />
                                <Route path="/users/:id" element={<SingleUser darkMode={darkMode} collapsed={collapsed} />} />
                                <Route path="/users/update/:id" element={<EditUser darkMode={darkMode} collapsed={collapsed} />} />

                                <Route path='/create-house/:id' element={<CreateHouse darkMode={darkMode} collapsed={collapsed} />} />
                                <Route path='/allhouses' element={<AllHouses darkMode={darkMode} collapsed={collapsed} />} />
                                <Route path='/products/:id' element={<ProductDetail darkMode={darkMode} collapsed={collapsed} />} />

                                <Route path='/categories' element={<Categories darkMode={darkMode} collapsed={collapsed} />} />

                                <Route path="/banners" element={<Banners darkMode={darkMode} collapsed={collapsed} />} />

                                <Route path="/plans" element={<Plans darkMode={darkMode} collapsed={collapsed} />} />

                                <Route path='/broadcast' element={<AdminBroadcast darkMode={darkMode} collapsed={collapsed} />}/>

                                <Route path="*" element={<Navigate to="/admin" replace />} />
                            </Routes>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AdminPanel;